import { ref } from 'vue'
import { defineStore } from 'pinia'
import { CommonType } from '@/interface'

const fileUploadPinia = defineStore('fileUploadPinia', () => {
  const lists = ref<CommonType[]>([])
  function changeLists(arr: CommonType[]) {
    lists.value = arr
  }
  return { lists, changeLists }
})
export default fileUploadPinia
